import dynamic from 'next/dynamic';
export default {
  login: dynamic(() => import(/* webpackChunkName: "blazePbLogin" */'./Login'))
};
//# sourceMappingURL=index.js.map